import { makeStyles } from "@material-ui/core/styles";
import { StyleVariables } from "./StyleVariable";

/**
 * Material UI framework styling object
 * @type {StylesHook<Styles<Theme, {}, string>>}
 */
const useStyles = makeStyles(theme => ({
  // Root container styles
  root: {
    padding: theme.spacing(0), // No padding
    maxWidth: "100%", // Full width
    height: "100vh", // Full viewport height
  },

  // Root container for new layout
  rootNew: {
    height: "100vh", // Full viewport height
    display: "flex", // Flexbox layout
    justifyContent: "space-evenly", // Evenly spaced children
    alignItems: "center", // Center align items vertically
    padding: theme.spacing(0), // No padding
    background: "#1d2136", // Background color
    maxWidth: "100%", // Full width
  },

  // Paper container for new layout
  paperNew: {
    marginTop: theme.spacing(0), // No margin at the top
    display: "flex", // Flexbox layout
    flexDirection: "row", // Horizontal layout
    alignItems: "center", // Center align items vertically
    height: "75%", // 75% of the parent height
    maxHeight: "500px", // Maximum height
    width: "50%", // 50% of the parent width
    borderRadius: "14px", // Rounded corners
  },

  // Paper container for mobile layout
  paperNewM: {
    marginTop: theme.spacing(0), // No margin at the top
    display: "flex", // Flexbox layout
    flexDirection: "column", // Vertical layout
    alignItems: "center", // Center align items horizontally
    height: "auto", // Automatic height
    width: "85%", // 85% of the parent width
    borderRadius: "12px", // Rounded corners
  },

  // Paper container for default layout
  paper: {
    marginTop: theme.spacing(0), // No margin at the top
    display: "flex", // Flexbox layout
    flexDirection: "row", // Horizontal layout
    alignItems: "center", // Center align items vertically
    height: StyleVariables.fullHeight, // Full height
  },

  // Form styles
  form: {
    width: StyleVariables.fullWidth, // Full width
    marginTop: theme.spacing(1), // Margin at the top
  },

  // Link item styles
  linkItem: {
    color: StyleVariables.mutedColor, // Muted color for text
    textDecoration: "none", // No underline
    "&:hover": {
      textDecoration: "underline", // Underline on hover
    },
  },

  // Spacing utilities
  spaceTop: {
    marginTop: theme.spacing(1), // Small margin at the top
  },
  spaceTop2: {
    marginTop: theme.spacing(2), // Medium margin at the top
  },
  spaceTop3: {
    marginTop: theme.spacing(3), // Large margin at the top
  },
  spaceBottom: {
    marginBottom: theme.spacing(1), // Small margin at the bottom
  },
  spaceBottom2: {
    marginBottom: theme.spacing(2), // Medium margin at the bottom
  },

  // Login font styles
  loginFont: {
    fontFamily: "inherit", // Inherit font family
  },

  // Back button styles for login
  loginBackButton: {
    marginTop: theme.spacing(1), // Small margin at the top
    marginBottom: theme.spacing(1), // Small margin at the bottom
  },

  // Brand logo styles
  brandLogo: {
    maxWidth: "200px", // Maximum width
    alignItems: "center", // Center align items horizontally
    justifyContent: "center", // Center align items vertically
    width: StyleVariables.fullWidth, // Full width
    display: "flex", // Flexbox layout
    color: StyleVariables.whiteColor, // White color for text
  },

  // Brand tagline styles
  brandTag: {
    alignItems: "center", // Center align items horizontally
    justifyContent: "center", // Center align items vertically
    width: StyleVariables.fullWidth, // Full width
    color: StyleVariables.whiteColor, // White color for text
  },

  // Panel width styles
  panelWidth: {
    width: "50%", // 50% of the parent width
    [theme.breakpoints.down("md")]: {
      width: "100%", // Full width for medium and smaller screens
    },
  },

  // Forgot button styles
  forgotButton: {
    marginBottom: "4%", // Margin at the bottom
  },

  // Inner form styles for authentication
  authInnerForm: {
    textAlign: StyleVariables.alignCenter, // Center align text
    margin: StyleVariables.alignAuto, // Auto margin
    width: "100%", // Full width
    [theme.breakpoints.up("sm")]: {
      width: "100%", // Full width for small screens and above
    },
    [theme.breakpoints.up("lg")]: {
      width: "90%", // 90% width for large screens and above
    },
    [theme.breakpoints.up("xl")]: {
      width: "80%", // 80% width for extra-large screens and above
    },
  },

  // Admin card styles
  adminCard: {
    height: "30vh", // 30% of the viewport height
  },

  // Tiles card styles
  tilesCard: {
    height: "100%", // Full height
    borderRadius: "4px", // Rounded corners
    position: StyleVariables.relative, // Relative positioning
    zIndex: "1", // Z-index for stacking context
    "&:after": {
      position: StyleVariables.absolute, // Absolute positioning
      height: StyleVariables.fullHeight, // Full height
      width: StyleVariables.fullWidth, // Full width
      top: StyleVariables.spacingZero, // No offset from the top
      bottom: StyleVariables.spacingZero, // No offset from the bottom
      left: StyleVariables.spacingZero, // No offset from the left
      right: StyleVariables.spacingZero, // No offset from the right
      zIndex: "-1", // Send to the back
    },
  },
}));

// Export the useStyles hook
export default useStyles;
